import React, { useState } from "react";
import LogoUpload from "./LogoUpload.js";
import CoverImageUpload from "./CoverImageUpload.js";
import Image from "components/Elements/Image/Image.tsx";
import SenderDetails from "./SenderDetails.js";
import { useUser } from "contexts/userContext/userContext.js";
import config from "config.ts";

const defaultBackground = `${config.api.resource}/assets/images/backgrounds/defaultGalleryBackgroundCover1.webp`;

const CoverAndLogoContent = () => {
  const { getUserData } = useUser();
  const userData = getUserData();
  const [coverBackground, setCoverBackground] = useState(
    userData.UserBackgroundCoverImage
      ? userData.UserBackgroundCoverImage
      : defaultBackground
  );
  return (
    <div className="cover-logo-content">
      <div className="cover-logo-background-image">
        <Image src={coverBackground} alt="" title="" />
      </div>
      <CoverImageUpload
        coverBackground={coverBackground}
        setCoverBackground={setCoverBackground}
      />
      <LogoUpload />
      <SenderDetails />
    </div>
  );
};

export default CoverAndLogoContent;
